document.addEventListener("DOMContentLoaded", () => {

    const frontInput = document.getElementById("gravur-vorne");
    const backInput = document.getElementById("gravur-rueckseite");

    const frontCounter = document.getElementById("gravur-vorne-counter");
    const backCounter = document.getElementById("gravur-rueckseite-counter");

    const backWrapper = document.getElementById("rendelwerk-rueckseite");
    const logoHint = document.getElementById("hinweis-logo");
    const gravurTyp = document.getElementById("gravurtyp");

    /* -----------------------------
       Zeichenzähler
    ------------------------------ */

    function updateCounter(input, counter) {

        if (!input || !counter) return;

        counter.textContent = input.value.length;

        const wrapper = counter.parentElement;

        if (input.value.length >= input.maxLength) {
            wrapper.classList.add("limit");
        } else {
            wrapper.classList.remove("limit");
        }

    }

    /* -----------------------------
       Variante erkennen
    ------------------------------ */

    function isDoubleSided() {

        const checkedRadio = document.querySelector(
            'input[type="radio"]:checked'
        );

        if (
            checkedRadio &&
            checkedRadio.value.toLowerCase().includes("beid")
        ) {
            return true;
        }

        const selects = document.querySelectorAll("select");

        for (const select of selects) {

            const value = select.options[select.selectedIndex].text.toLowerCase();

            if (value.includes("beid")) {
                return true;
            }

        }

        return false;

    }

    /* -----------------------------
       Rückseite anzeigen
    ------------------------------ */

    function updateBackSide() {

        if (!backWrapper) return;

        if (isDoubleSided()) {

            backWrapper.hidden = false;
            backWrapper.style.display = "block";

            if (backInput) {
                backInput.disabled = false;
            }

            if (logoHint) {
                logoHint.style.display = "none";
            }

            if (gravurTyp) {
                gravurTyp.value = "Beidseitig";
            }

        } else {

            backWrapper.hidden = true;
            backWrapper.style.display = "none";

            if (backInput) {
                backInput.value = "";
                backInput.disabled = true;
            }

            if (logoHint) {
                logoHint.style.display = "block";
            }

            if (gravurTyp) {
                gravurTyp.value = "Einseitig";
            }

            updateCounter(backInput, backCounter);

        }

    }

    /* -----------------------------
       Fehlerfunktionen
    ------------------------------ */

    function removeErrors() {

        document.querySelectorAll(".gravur-error").forEach(el => el.remove());

        document.querySelectorAll(".gravur-error-field").forEach(el => {
            el.classList.remove("gravur-error-field");
        });

    }

    function showError(field, text) {

        field.classList.add("gravur-error-field");

        const error = document.createElement("div");

        error.className = "gravur-error";

        error.textContent = text;

        field.insertAdjacentElement("afterend", error);

    }

    /* -----------------------------
       Event Listener
    ------------------------------ */

    if (frontInput) {
        frontInput.addEventListener("input", () => {
            updateCounter(frontInput, frontCounter);
            removeErrors();
        });
    }

    if (backInput) {
        backInput.addEventListener("input", () => {
            updateCounter(backInput, backCounter);
            removeErrors();
        });
    }

    document.addEventListener("change", (event) => {

        if (
            event.target.matches("input[type='radio']") ||
            event.target.matches("select")
        ) {
            updateBackSide();
        }

    });

    document.addEventListener("variant:change", () => {
        updateBackSide();
    });

    /* -----------------------------
       Formularvalidierung
    ------------------------------ */

    const form = document.querySelector('form[action*="/cart/add"]');

    if (form) {

        form.addEventListener("submit", function (event) {
console.log("Rendelwerk Validierung gestartet");
            let valid = true;

            removeErrors();

            if (frontInput && frontInput.value.trim() === "") {

                showError(
                    frontInput,
                    "Bitte gib deine Wunschgravur für die Vorderseite ein."
                );

                valid = false;

            }

            if (
                backWrapper &&
                !backWrapper.hidden &&
                backInput &&
                backInput.value.trim() === ""
            ) {

                showError(
                    backInput,
                    "Bitte gib deine Wunschgravur für die Rückseite ein."
                );

                valid = false;

            }

            if (!valid) {

                event.preventDefault();

                const firstError = document.querySelector(".gravur-error-field");

                if (firstError) {
                    firstError.focus();
                }

            }

        });

    }

    /* -----------------------------
       Initialisierung
    ------------------------------ */

    updateCounter(frontInput, frontCounter);
    updateCounter(backInput, backCounter);
    updateBackSide();

});